import React from "react";
import { cva } from "class-variance-authority";

import { cn } from "utils/cn";

const alertVariants = cva("mb-4 flex items-center rounded-lg border p-4 text-sm", {
  variants: {
    type: {
      primary: "border-blue-300 bg-blue-50 text-blue-800",
      danger: "border-red-300 bg-red-50 text-red-800",
      success: "border-green-300 bg-green-50 text-green-800",
      warning: "border-yellow-300 bg-yellow-50 text-yellow-800",
      secondary: "border-gray-300 bg-gray-50 text-gray-800",
    },
  },
  defaultVariants: {
    type: "primary",
  },
});

export const Alert = ({ children, type, className }) => {
  return (
    <div className={cn(alertVariants({ type }), className)} role="alert">
      <svg className="me-3 inline h-4 w-4 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
      </svg>
      <div className="flex-1">{children}</div>
    </div>
  );
};
